<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @hotelDetailCurrency="hotelDetailCurrency" @getPublicCurrency="getPublicCurrency" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content" ref="contentWidth">
        <slot>
          <el-main>
            <div class="main" >
              <publicSearchCond ref="child" :regionSelData="regionSelDetail" :hotelRoomSearchFixed="hotelRoomSearchFixed" :hotelRoomSearchFixedPlaceholder="hotelRoomSearchFixedPlaceholder" :personWidth="personWidth" @getSearchInfo="getSearchInfo" :allPermissions="allPermissions"></publicSearchCond>
              <!--详情页 开始-->
              <!-- <div class="list-content" :style="heightCss"> -->
              <div class="list-content">
                <div style="width: 100%;min-height: 250px;">
                  <el-skeleton animated :loading="hotelShow">
                    <template slot="template">
                      <div class="img-info">
                        <div style="width: 40%; float: left;">
                          <div style="width:66%;height:250px;float:left;">
                            <el-skeleton-item variant="text" class="main-img" />
                          </div>
                          <div style="width: 32%;height:100%; margin-left:1%; float:left;">
                            <div style=" width: 100%; height: 120px; margin-bottom: 10px;">
                              <el-skeleton-item variant="text" class="main-img" />
                            </div>
                            <div style=" width: 100%; height: 120px;">
                              <el-skeleton-item variant="text" class="main-img" />
                            </div>
                          </div>
                        </div>
                        <div style="width: 59%; float: right;">
                          <div class="hotelname-info"><el-skeleton-item variant="text" style="width: 70%; height: 30px;" /></div>
                          <div><el-skeleton-item variant="text" style="width: 100px; height: 20px;" /></div>
                          <div class="hotel-contact-info">
                            <el-skeleton-item variant="text" style="width: 80%;" />
                          </div>
                          <div class="hotel-contact-info">
                            <el-skeleton-item variant="text" style="width: 80%;" />
                          </div>
                          <div class="hotel-contact-info">
                            <el-skeleton-item variant="text" style="width: 80%;" />
                          </div>
                          <div>
                            <el-skeleton-item variant="text" style="width: 120px; margin-top: 15px;" />
                          </div>
                          <div>
                            <el-skeleton-item variant="text" style="width: 80%; margin-top: 15px;" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template>
                      <div class="img-info">
                        <div style="width: 35%; float: left;">
                          <div style="width:66%;height:250px;float:left; position: relative;">
                            <img :src="hotelImg[0].url" class="main-img">
                            <div v-show="hotelImg[1].caption_en === 'default'" class="default-pic">
                              <div class="default-pic-text">No picture</div>
                            </div>
                          </div>
                          <div style="width: 32%;height:100%; margin-left:6px; float:left;">
                            <div style=" width: 100%; height: 122px; margin-bottom: 6px; position: relative;">
                              <img :src="hotelImg[1].url" class="main-img">
                              <div v-show="hotelImg[1].caption_en === 'default'" class="default-pic">
                                <div class="default-pic-text">No picture</div>
                              </div>
                            </div>
                            <div style=" width: 100%; height: 122px; position: relative;">
                              <img :src="hotelImg[2].url" class="main-img">
                              <span v-if="hotelImg[2]['defect'] === 0" class="all-photos" @click="seeMorePicturesShow($event)">{{$t('seeAllPhotos')}}</span>
                              <div v-show="hotelImg[2].caption_en === 'default'" class="default-pic">
                                <div class="default-pic-text">No picture</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="width: 64%; float: right;">
                          <div class="hotelname-info">{{hotel.hotelname}}</div>
                          <div v-if="hotelInfo.star !== 0" style=" height: 35px; line-height: 35px;">
                            <b style="margin-right: 3px;" v-for="val in hotelInfo.star" :key="val">
                              <img style="width:15px;height:15px;" src="/static/img/star.png">
                            </b>
                            <b style="margin-left: -3px;" v-if="hotelInfo.star_decimal === 1">
                              <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                            </b>
                          </div>
                          <div v-else style=" height: 35px;"></div>
                          <div class="hotel-contact-info">
                            <div v-if="hotel.hoteladdress !== ''">
                              <img src="/static/img/account/location.png" alt="">
                              <div style="margin-left:10px;">{{hotel.hoteladdress}}</div>
                            </div>
                          </div>
                          <div class="hotel-contact-info">
                            <div v-if="hotelInfo.telphone !== ''">
                              <img src="/static/img/account/my-hotelphone.png" alt="">
                              <div style="margin-left:10px;">{{hotelInfo.telphone}}</div>
                            </div>
                          </div>
                          <div class="hotel-contact-info">
                            <div v-if="hotelInfo.email !== ''">
                              <img src="/static/img/account/my-hotelemail.png" alt="">
                              <div style="margin-left:10px;">{{hotelInfo.email}}</div>
                            </div>
                          </div>
                          <div style="width: 100%;">
                            <el-collapse accordion>
                              <el-collapse-item>
                                <template>
                                  <div slot="title" style="font-weight: 500;margin-top: 15px; font-size: 14px; border: none; height: 60px;">
                                    <div style="width: 100%; height: 35px;">Hotel description</div>
                                    <div class="overview-info" style="font-size: 13px;font-weight: 400;height: 20px;">
                                      <span style="margin-right: 15px;" v-if="hotelInfo.open_time !== '' && hotelInfo.open_time !== '0'"><span style="font-weight: 500;">{{$t('opened')}}:</span> {{hotelInfo.open_time}}</span>
                                      <span style="margin-right: 15px;" v-if="hotelInfo.roominventry > 0"><span style="font-weight: 500;">{{$t('roomNumber')}}:</span> {{hotelInfo.roominventry}}</span>
                                      <span style="margin-right: 15px;" v-if="hotelInfo.telphone !== ''"><span style="font-weight: 500;">{{$t('telephone')}}:</span> {{hotelInfo.telphone}}</span>
                                      <span style="color:#296ff7;">More ...</span>
                                    </div>
                                  </div>
                                </template>
                                <div style=" margin-top: 35px;">
                                  <div><span v-html="hotelInfo.hotel_introduction_en"></span></div>
                                  <div><span v-html="hotelInfo.hotel_location_en"></span></div>
                                  <div><span v-html="hotelInfo.room_features_en"></span></div>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                </div>
                <!-- 查看更多图片 -->
                <div ref="seeMorePictures" class="seeMorePictures">
                  <div class="pricturesMask" @click="seeMorePicturesHide($event)"></div>
                  <div class="morePrictures">
                    <div class="morePricturesImg">
                      <div class="morePricturesLeft">
                          <span class="firstSpan" @click="prevImgShow">
                            <img src="/static/img/hotelsearch/showImgLeft.png" alt="">
                          </span>
                          <img :src="hotelImg['0']['url']" ref="morePricturesMax" data-index="0" alt="">
                          <span class="lastSpan" @click="nextImgShow">
                            <img src="/static/img/hotelsearch/showImgRight.png" alt="">
                          </span>
                      </div>
                      <div class="morePricturesRight" >
                        <div class="morePricturesRightImg" v-for="item in hotelImg" :key="item.id">
                          <img :src="item.url"  alt="" :dataIndex="item.id" ref="currentPictures">
                          <div ref="currentPicturesDiv" @click="curImgShow($event)" :dataIndex="item.id"></div>
                        </div>
                      </div>
                    </div>
                    <div class="closeRight">
                        <span @click="seeMorePicturesHide($event)">×</span>
                    </div>
                  </div>
              </div>
                <!-- 介绍 结束 -->
                <!-- 报价 开始 -->
                <div style="background-color: #FFF; clear: both; margin-top: 20px;">
                  <el-skeleton animated :loading="isPriceShow">
                    <template slot="template">
                      <div class="pricelist" style="width: 98%; background-color: rgba(242, 242, 242, 1);border-radius: 5px;height: 40px;border: none; font-weight: 650; font-size: 14px; color: #333333; line-height: 40px; padding: 0 1%;border-bottom: 1px solid #d2cfcf;">
                        <div style="width: 14%;padding-right: 10px;"><el-skeleton-item variant="text" class="title-txt" /></div>
                        <div style="width: 84%;">
                          <div style="width: 14%;"><el-skeleton-item variant="text" class="title-txt" /></div>
                          <div style="width: 14%;padding-right: 10px;"><el-skeleton-item variant="text" class="title-txt" /></div>
                          <div style="width: 14%;"><el-skeleton-item variant="text" class="title-txt" /></div>
                          <div style="width: 10%;"><el-skeleton-item variant="text" class="title-txt" /></div>
                          <div style="width: 20%;"><el-skeleton-item variant="text" class="title-txt" /></div>
                          <div style="width: 12%;"><el-skeleton-item variant="text" class="title-txt" /></div>
                          <div style="width: 14%;"></div>
                        </div>
                      </div>
                    </template>
                    <template>
                      <div class="pricelist" style="width: 98%; background-color: rgba(242, 242, 242, 1);border-radius: 5px; height: 40px;border: none; font-weight: 650; font-size: 14px; color: #333333; line-height: 40px; padding: 0 1%;border-bottom: 1px solid #d2cfcf;">
                        <div style="width: 14%;padding-right: 10px;">Room type</div>
                        <div style="width: 84%;">
                          <div style="width: 14%;">Room Amenities</div>
                          <div style="width: 14%;padding-right: 10px;">Bedtype</div>
                          <div style="width: 14%;">Product type</div>
                          <div style="width: 10%;">Breakfast</div>
                          <div style="width: 20%;">Cancellation policy</div>
                          <div style="width: 12%; text-align: center;">Total price</div>
                          <div style="width: 14%;"></div>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                  <el-skeleton :count="10" animated :loading="isPriceShow">
                    <template slot="template">
                      <div class="price-info" style="height: 65px;">
                        <div class="price-info-val">
                          <div class="parent-room" style="height:65px; line-height: 65px;padding-right: 10px;">
                            <span><el-skeleton-item variant="text" class="list-txt" /></span>
                          </div>
                          <div class="price-item">
                            <div style="width: 14%;font-size: 14px;"><el-skeleton-item variant="text" class="list-txt" /></div>
                            <div style="width: 14%;font-size: 14px;padding-right: 10px;"><el-skeleton-item variant="text" class="list-txt" /></div>
                            <div style="width: 14%;font-size: 14px;"><el-skeleton-item variant="text" class="list-txt" /></div>
                            <div style="width: 10%;font-size: 14px;"><el-skeleton-item variant="text" class="list-txt" /></div>
                            <div style="width: 20%;font-size: 14px;"><el-skeleton-item variant="text" class="list-txt" /></div>
                            <div style="width: 12%;font-size: 14px;"><el-skeleton-item variant="text" class="list-txt" /></div>
                            <div style="width: 14%;"><el-skeleton-item variant="text"  style=" margin-top: 12.5px;width: 140px;height: 40px;float: right;"/>
                          </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template>
                      <div class="price-info" :style="{ height: `${item.parentInfo.roomHeight}px`}" v-for="(item,i) in roomList" :key="i" v-show="roomList.length>0 && (item.parentInfo.parentRoomShow === '1' || item.parentInfo.parentRoomShow === 1)">
                          <div class="price-info-val">
                            <div class="parent-room" :style="{ height: `${item.parentInfo.roomHeight}px` }" style="padding-right: 10px; display: flex; flex-direction: column; justify-content: center;">
                                <el-tooltip
                                  :content="item['parentInfo'].name_en"
                                  placement="top"
                                  effect="light"
                                  >
                                  <span class="room-name" style="margin-top: 10px; margin-bottom: 10px; line-height: 1.2;">{{item['parentInfo'].name_en}}</span>
                                </el-tooltip>
                            </div>
                            <div class="price-item" :class="{'price-border': k !== item['priceInfo'].length - 1}" v-for="(price,k) in item['priceInfo']" :key="k" v-show="price.selected">
                              <div style="width: 14%;font-size: 14px;"><a href="javascript:;" @click="showFacilities(price)" style="font-size: 14px; text-align: left; margin-bottom: 5px;">Facilities & Amenities</a></div>
                              <div style="width: 14%;font-size: 14px;display: flex;align-items: center;padding-right: 10px;">
                                <!-- <el-tooltip
                                  :content="price.bedGroups[0].description"
                                  placement="top"
                                  effect="light"
                                  >
                                  <span style="cursor: pointer;" class="room-name">{{price.bedGroups[0].description}}</span>
                                </el-tooltip> -->
                                <el-select v-model="price.selectedBedGroupId" placeholder="请选择" style="width: 100%;">
                                  <el-option
                                    v-for="bedGroup in price.bedGroups"
                                    :key="bedGroup.id"
                                    :label="bedGroup.description"
                                    :value="bedGroup.id">
                                  </el-option>
                                </el-select>
                                <el-tooltip
                                  content="Please note: While we do our best to accommodate all bed type requests,they are subject to availability at the time of check-in and cannot be guaranteed."
                                  placement="top"
                                  effect="light"
                                  >
                                  <span style="cursor: pointer;color: #000000D9;margin-left: 3px;display: inline-flex;align-items: center;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                    <g clip-path="url(#clip0_694_740)">
                                      <path d="M7.5 0.9375C3.87598 0.9375 0.9375 3.87598 0.9375 7.5C0.9375 11.124 3.87598 14.0625 7.5 14.0625C11.124 14.0625 14.0625 11.124 14.0625 7.5C14.0625 3.87598 11.124 0.9375 7.5 0.9375ZM7.5 12.9492C4.49121 12.9492 2.05078 10.5088 2.05078 7.5C2.05078 4.49121 4.49121 2.05078 7.5 2.05078C10.5088 2.05078 12.9492 4.49121 12.9492 7.5C12.9492 10.5088 10.5088 12.9492 7.5 12.9492Z" fill="black" fill-opacity="0.85"/>
                                      <path d="M6.79665 4.92187C6.79665 5.10836 6.87072 5.2872 7.00259 5.41906C7.13445 5.55092 7.31329 5.625 7.49977 5.625C7.68625 5.625 7.86509 5.55092 7.99695 5.41906C8.12882 5.2872 8.2029 5.10836 8.2029 4.92187C8.2029 4.73539 8.12882 4.55655 7.99695 4.42469C7.86509 4.29283 7.68625 4.21875 7.49977 4.21875C7.31329 4.21875 7.13445 4.29283 7.00259 4.42469C6.87072 4.55655 6.79665 4.73539 6.79665 4.92187ZM7.85133 6.5625H7.14821C7.08376 6.5625 7.03102 6.61523 7.03102 6.67969V10.6641C7.03102 10.7285 7.08376 10.7812 7.14821 10.7812H7.85133C7.91579 10.7812 7.96852 10.7285 7.96852 10.6641V6.67969C7.96852 6.61523 7.91579 6.5625 7.85133 6.5625Z" fill="black" fill-opacity="0.85"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_694_740">
                                        <rect width="15" height="15" fill="white"/>
                                      </clipPath>
                                    </defs>
                                  </svg></span>
                                </el-tooltip>
                              </div>
                              <div style="width: 14%;font-size: 14px;" v-if="item['parentInfo'].name_en === 'Others'">
                                <el-tooltip class="others-room" effect="light" :content="price.name" placement="top-start">
                                  <span class="green-text">{{price.name}}</span>
                                </el-tooltip>
                                <div style="height: 20px; line-height: 20px;">
                                  Instant confirmation
                                </div>
                              </div>
                              <div style="width: 14%;font-size: 14px;" v-else>Instant confirmation</div>
                              <div style="width: 10%;font-size: 14px;" :class="{'green-text': price.breakfast === 'Free breakfast'}">{{price.breakfast}}</div>
                              <div style="width: 20%;font-size: 14px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                                <el-popover
                                  placement="left"
                                  width="350"
                                  trigger="hover"
                                  popper-class="nonFefundable"
                                >
                                <div class="cancel-policy">
                                  <div class="title">Cancellation Policy</div>
                                  <div class="content-wrapper">  <!-- 新增一个包装容器 -->
                                    <div v-for="(item, i) in price.cancelPenalties.list" :key="i" class="content-item">  <!-- 修改class名避免冲突 -->
                                      <span class="circle" :style="{ border: '2px solid ' + setCancellationColor(item.type) }"></span>
                                      <div class="text-content">
                                        <div class="subtitle">{{ item.title }}</div>
                                        <div class="description">{{ item.desc }}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <span slot="reference" style="cursor:pointer;" :style="{ color: setCancellationColor(price.cancelPenalties.cancellation.type)}">{{price.cancelPenalties.cancellation.title}}</span>
                                </el-popover>
                              </div>
                              <div class="price-infos">
                                <div class="price-title-data-top">
                                  <el-popover placement="left" width="350" trigger="hover" popper-class="price-title">
                                    <div class="price-title-data-detail" style="width:100%;">
                                      <div class="price-title-data-detail-top">
                                        <div class="price-title-data-detail-center">
                                          {{$t('priceDetails')}}
                                        </div>
                                      </div>
                                      <div class="price-title-data-detail-body">
                                        <div style=" padding-bottom: 10px;">
                                          <!-- price -->
                                          <div class="price-title-data-detail-line">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{searchPriceData.roomcount}}{{$t('onOurSite')}} x {{searchPriceData.nightCount}}{{$t('night')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                {{price.currency}} {{price.fareTotal}}
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('avgNight')}} {{price.currency}} {{price.fare}}</span>
                                            </div>
                                          </div>
                                          <!-- tax -->
                                          <div class="price-title-data-detail-line">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('taxesFees')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                {{price.currency}} {{price.curTax}}
                                              </div>
                                            </div>
                                          </div>
                                          <!-- payableAtProperty -->
                                          <div class="price-title-data-detail-line" v-if="price.mandatoryFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('mandatoryFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.mandatoryFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.mandatoryFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.mandatoryTax !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('mandatoryTax')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.mandatoryTax}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.mandatoryTax !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.resortFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('resortFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.resortFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.resortFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.cityFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('cityTaxFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.cityFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.cityFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.destinationFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('destinationFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.destinationFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.destinationFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.serviceFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('serviceFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.serviceFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.serviceFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.CleaningFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('cleaningFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.CleaningFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.CleaningFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-line" v-if="price.administrativeFee !== ''">
                                            <div class="price-title-data-detail-center">
                                              <div class="price-title-data-detail-line-left">
                                                <span>{{$t('administrativeFee')}}</span>
                                              </div>
                                              <div class="price-title-data-detail-line-right">
                                                <span>{{price.administrativeFee}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="price-title-data-detail-min" v-if="price.administrativeFee !== ''">
                                            <div class="price-title-data-detail-center font-min">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Total Price -->
                                        <div class="price-title-data-detail-line" style=" padding-top: 10px; border-top: 1px solid rgba(83, 102, 163, 1);">
                                          <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
                                            <div class="price-title-data-detail-line-left">
                                              <span>{{$t('totalPrice')}}</span>
                                            </div>
                                            <div class="price-title-data-detail-line-right">
                                              {{price.currency}} {{price.totalPrice}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="price-title-data-detail-min" :class="{'price-padding': price.payPriceShow === false || price.payPriceShow === 'false'}">
                                          <div class="price-title-data-detail-center font-min">
                                            <span>{{$t('includesTaxesFees')}}</span>
                                          </div>
                                        </div>
                                        <!-- Pay Now -->
                                        <div class="price-title-data-detail-line" style="padding-bottom:10px;" v-if="price.payPriceShow === true || price.payPriceShow === 'true'">
                                          <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
                                            <div class="price-title-data-detail-line-left">
                                              <span>{{$t('payNow')}}</span>
                                            </div>
                                            <div class="price-title-data-detail-line-right">
                                              {{price.currency}} {{price.payPrice}}
                                            </div>
                                          </div>
                                        </div>
                                        <!-- Payable at property -->
                                        <div class="price-title-data-detail-line" style="padding-bottom:0px;" v-if="price.payableAtProperty && price.payableAtProperty !== '0' && price.payableAtProperty !== 0">
                                          <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
                                            <div class="price-title-data-detail-line-left">
                                              <span>{{$t('payableAtProperty')}}</span>
                                            </div>
                                            <div class="price-title-data-detail-line-right">
                                              {{price.currency}} {{price.payableAtProperty}}
                                            </div>
                                          </div>
                                        </div>
                                        <!-- 积分 -->
                                        <div class="price-title-data-detail-line" style="height:10%;padding:0px;" v-if="price.points && price.points !== '0' && price.points !== 0 && price.pointsCashValue">
                                          <div class="price-title-data-detail-center" style="font-weight: 400;font-size: 14px;">
                                              <span>If you book and successfully check-in, you will earn {{Number(price.points).toLocaleString()}} points (worth {{price.pointsCashValue}}).</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- 积分 -->
                                    <span slot="reference">
                                      <div style="float: right; display: contents;">
                                        <span style="cursor:pointer;display: inline;border-bottom: dashed 1px #E12D2D;">
                                          <span class="currencyTag-info">{{price.currencyTag}}</span>
                                          <span class="payPrice-info">{{price.payPrice}}</span>
                                        </span>
                                        <span class="package-tag" v-if="price.isPkg == 1">
                                          Package
                                        </span>
                                      </div>
                                    </span>
                                  </el-popover>
                                </div>
                              </div>
                              <div style="width: 14%;">
                                <button type="button" v-if="allPermissions.order === 0" style=" margin-top: 12.5px; float: right;" class="display_button">Book now</button>
                                <button type="button" v-else style=" margin-top: 12.5px; float: right;" class="white_button" @click="parentRoomBook(price)">Book now</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="price-info" v-show="roomList.length === 0" style="text-align: center;margin: 90px 0;">
                          Sorry, we have no rooms at this property on your dates.
                        </div>
                    </template>
                  </el-skeleton>
                </div>
                <!-- 报价 结束 -->
              </div>
              <!--详情页 结束-->
              <div class="container">
                <h1>Hotel Policies</h1>
                <div class="policy-columns">
                  <div class="policy-column">
                    <div class="policy-module" v-if="hotelPolicyData.checkin_begin_time">
                      <h2>Check In</h2>
                      <div>Check in time: {{hotelPolicyData.checkin_begin_time}} - {{hotelPolicyData.checkin_end_time}}</div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.checkout_time_en">
                      <h2>Check out</h2>
                      <div>Check out time: {{hotelPolicyData.checkout_time_en}}</div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.hotel_checkin_instructions_en">
                      <h2>Instructions</h2>
                      <div class="policy-content" v-html="hotelPolicyData.hotel_checkin_instructions_en"></div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.special_instructions_en">
                      <h2>Special Instructions</h2>
                      <div class="policy-content" v-html="hotelPolicyData.special_instructions_en"></div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.fees_mandatory_en">
                      <h2>Fees</h2>
                      <div class="policy-content" v-html="hotelPolicyData.fees_mandatory_en"></div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.other_policies_en">
                      <h2>Policies</h2>
                      <div class="policy-content" v-html="hotelPolicyData.other_policies_en"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
    <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog" :checkIn="checkIn" :checkOut="checkOut" :nationality="nationality"></frameHotelSold>
    <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice" :curPageData="curPageData" @frameRiseBookingBackFun="frameRiseBookingBackFun"></frameRise>
    <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog" :nationality="nationality"></frameHomeSold>
    <publicHotelDetailInfo :whatNearbyShow="whatNearbyShow" :travelAroundData="travelAround" @closepop="closepopEven"></publicHotelDetailInfo>
    <publicHotelDetailInfo :hotelPriceRoomImgShow="hotelPriceRoomImgShow" :hotelPriceRoomData="hotelPriceRoom" @closepop="closepopEven"></publicHotelDetailInfo>
    <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
    <frameChangeRoom :frameChangeRoomDialog="frameChangeRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" @frameChangeRoomBookingBackFun="frameChangeRoomBookingBackFun"></frameChangeRoom>
    <frameChangePriceAndRoom :frameChangePriceAndRoomDialog="frameChangePriceAndRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" :risePrice="risePrice" @frameChangePriceAndRoomBookingBackFun="frameChangePriceAndRoomBookingBackFun"></frameChangePriceAndRoom>
    <el-dialog
      title="Facilities & Amenities"
      :visible.sync="facilitiesDialogVisible"
      width="30%"
      custom-class="facilities-dialog"
      >
      <div class="facilities-divider"></div>
      <ul class="facilities-list">
        <li v-for="item in amenities" :key="item.name">
          <span class="arrow-icon">►</span>
          <span>{{ item.name }}</span>
        </li>
        <li v-for="item in promotions" :key="item.id">
          <span class="arrow-icon">►</span>
          <span>{{ item.description }}</span>
        </li>
      </ul>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="facilitiesDialogVisible = false">Close</el-button>
      </span> -->
    </el-dialog>
  </el-container>
  </template>

<script>
import { hotelDetail, hotelImg, hotelQuotedprice, recommendHotel, getCityId, hotelPolicyNew } from '@/request/hotel.js'
import { orderBookVerify } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import publicSearchCond from '@/components/public/publicSearchCond'
import frameHotelSold from '@/components/public/frameHotelSold'
import frameHomeSold from '@/components/public/frameHomeSold'
import frameRise from '@/components/public/frameRise'
import publicHotelDetailInfo from '@/components/public/publicHotelDetailInfo'
import publicMask from '@/components/public/publicMask'
import frameChangeRoom from '@/components/public/frameChangeRoom'
import frameChangePriceAndRoom from '@/components/public/frameChangePriceAndRoom'
export default {
  name: 'HotelDetail',
  components: {
    publicFooter,
    publicHeader,
    publicMenu,
    publicSearchCond,
    frameHotelSold,
    frameHomeSold,
    frameRise,
    publicHotelDetailInfo,
    publicMask,
    frameChangeRoom,
    frameChangePriceAndRoom
  },
  data () {
    return {
      curPageData: 'HotelDetail',
      isFullscreen: true,
      mainMinHeight: document.documentElement.clientHeight - 225,
      heightCss: {'min-height': '500px'},
      hotelRoomSearchPcFixed: '',
      hotelRoomSearchPcFixedPlaceholder: {'display': 'none'},
      hotelRoomSearchMobileFixed: '',
      isPriceShow: true,
      priceEmpty: false,
      hotelid: '',
      screenWidth: 0,
      currencySwitch: this.common.currencySet(this),
      mapMobile: 0,
      hotel: {'hotelname': '', 'hotelname_zh': ''},
      hotelInfo: {},
      hotelImg: {},
      hotelPolicyData: {},
      hotelDistance: [{}, {}, {}],
      ispublic: false,
      hotelMobileImg: [],
      roomList: [],
      hotelFacility: [{}, {}, {}, {}, {}],
      travelAround: [],
      input_region: '',
      input_date: '',
      input_person: '',
      checked: '',
      checked_breakfast: false,
      checked_cancel: false,
      country: '',
      city: '',
      regions: {
        '7980': { 'id': '7980', 'type': '1', 'value': '纽约，美国', 'address': '纽约，美国', 'country': '美国', 'city': '纽约' },
        '767978': { 'id': '767978', 'type': '3', 'value': '大西洋城赌场度假酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '743455': { 'id': '743455', 'type': '3', 'value': '金块酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '438276': {'id': '438276', 'type': '3', 'value': '纽约曼哈顿时代广场酒店(The Manhattan at Times Square Hotel New York)', 'address': '纽约，美国', 'country': '美国', 'city': '纽约'}
      },
      frameHotelSoldDialog: false, // 酒店已售空的英文弹窗界面
      frameHomeSoldDialog: false, // 本酒店其他母房型报价
      frameRiseDialog: false, // 房型涨价
      risePrice: 0, // 涨价多少钱
      mapShow: false, // 地图是否展示
      cityData: {},
      hotelRoomSearchFixed: '',
      hotelRoomSearchFixedPlaceholder: '',
      hotelLogoFixed: '',
      language: this.common.languageSet(this),
      pet_notice: [],
      mobileOverview: false,
      mobilePracticalInformation: false,
      whatNearbyShow: false,
      hotelPriceRoom: {'url': '', 'roomname': ''},
      hotelPriceRoomImgShow: false,
      hotelSorceRemark: Math.floor(Math.random() * 7),
      regionSelDetail: {},
      fullscreenLoading: false,
      checkIn: '',
      checkOut: '',
      region: '',
      recommendHotelList: {},
      hotelShow: true,
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 64,
      personWidth: (document.body.clientWidth - 64) * 0.2182 - 10,
      source: this.common.sourceSet(),
      moreTextShow: true,
      publicCurrency: '',
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      sameRoomInfo: '',
      frameChangeRoomDialog: false, // 报价不变，房型变更
      frameChangePriceAndRoomDialog: false, // 报价变更，房型变更
      nationality: '',
      searchPriceData: {},
      facilitiesDialogVisible: false,
      promotions: [],
      amenities: []
    }
  },
  created () {
    if (this.isCollapse === true) {
      this.contentWidth = document.body.clientWidth - 64
      this.personWidth = (document.body.clientWidth - 64) * 0.2182 - 10
    } else {
      this.contentWidth = document.body.clientWidth - 215
      this.personWidth = (this.contentWidth * 0.2182) - 10
    }
    sessionStorage.removeItem('orderUserData')
    this.hotelShow = true
    this.region = this.$route.query.region
    this.hotelid = this.$route.query.hotelid
    var time = parseInt(new Date().getTime() / 1000)
    var language = this.common.languageSet(this)
    var currency = this.common.currencySet(this)
    var sessionid = this.common.sessionidGet(this)
    var token = this.$md5('0' + this.common.lfSignKey)
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token')
    }

    var dataJson = {'hotelid': this.hotelid, 'token': token, 'time': time, 'language': language, 'currency': currency, 'sessionid': sessionid}
    var data = this.common.encryptionData(dataJson, this)
    hotelDetail(data).then(res => {
      // 保留选择的目的地
      var regionSel = {'value_zh': res.data.hotel.hotelname_zh ? res.data.hotel.hotelname_zh : res.data.hotel.hotelname, 'value_en': res.data.hotel.hotelname, 'type_id': 3, 'type_data_id': this.hotelid}
      this.regionSelDetail = regionSel
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      if (this.region === undefined || this.region === '') {
        if (this.language === 'zh') {
          this.region = res.data.hotel.hotelname_zh
        } else {
          this.region = res.data.hotel.hotelname
        }
      }
      this.hotel = res.data.hotel
      this.hotelInfo = res.data.hotelInfo
      this.hotelDistance = res.data.hotelDistance
      this.hotelFacility = res.data.hotelFacility
      this.travelAround = res.data.travelAround
    })
    if (this.$route.query.is_pkg === 1 || this.$route.query.is_pkg === '1') {
      sessionStorage.setItem('searchAgreementChange', 1)
    } else {
      sessionStorage.removeItem('searchAgreementChange')
    }
    // hotelimg
    var imgDataJson = {'hotelid': this.hotelid, 'operation': 'hotelImg', 'time': time, 'sessionid': sessionid}
    var imgData = this.common.encryptionData(imgDataJson, this)
    hotelImg(imgData).then(res => {
      this.hotelImg = res.data.hotelImg
      this.ispublic = res.data.ispublic
    })

    var policyDataJson = {'hotelid': this.hotelid, 'operation': 'hotelPolicyNew', 'time': time, 'sessionid': sessionid}
    var policyData = this.common.encryptionData(policyDataJson, this)
    hotelPolicyNew(policyData).then(res => {
      this.hotelPolicyData = res.data
    })

    this.hotelShow = false
  },
  mounted () {
    this.heightCss = {'min-height': this.mainMinHeight + 'px'}
    // 下滑搜索条置顶
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth <= 1500) {
      this.screenWidth = 1500
    }
    // 存储来源
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // 页面被刷新
    // if (window.performance.navigation.type === 1) {
    //   localStorage.removeItem('searchData')
    // }
    var queryNationality = this.$route.query.nationality
    if (queryNationality !== '' && queryNationality !== undefined && queryNationality !== null) {
      this.nationality = queryNationality
    }

    // 获取报价
    this.hotelPrice()

    // 查城市ID
    this.getCityIdFun()

    // 关闭弹出
    window.addEventListener('click', this.bodyCloseMenus)
    // 回退按钮
    window.addEventListener('popstate', this.handleBackForwardButton)
  },
  watch: {
    screenWidth: {
      handler: function (val) {
        this.screenWidth = document.body.clientWidth
        if (this.screenWidth <= 1500) {
          this.screenWidth = 1500
        }
        this.contentWidth = this.$refs['contentWidth'].clientWidth
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 60) {
          let width = this.contentWidth - 30
          this.hotelRoomSearchFixed = {'width': width + 'px', 'position': 'fixed', 'top': '0px', 'z-index': 1999, 'margin': '0px auto'}
        } else {
          this.hotelRoomSearchFixed = ''
        }
      }
    },
    language: function (newCur, oldCur) {
      this.language = newCur
      if (this.language === 'zh') {
        this.pet_notice = this.hotelPolicy.pet_notice_zh_arr
      } else {
        this.pet_notice = this.hotelPolicy.pet_notice_en_arr
      }
    },
    currencySwitch: function (newCur, oldCur) {
      this.reload()
      this.hotelPrice()
    }
  },
  beforeDestroy () {
    window.removeEventListener('click', this.bodyCloseMenus)
    window.removeEventListener('popstate', this.handleBackForwardButton)
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    formattedSpecialInstructions () {
      if (!this.hotelPolicyData.special_instructions_en) {
        return ''
      }
      const sentences = this.hotelPolicyData.special_instructions_en.split('.').filter(sentence => sentence.trim() !== '')
      const listItems = sentences.map(sentence => `<li>${sentence.trim()}.</li>`).join('')
      return `<ul>${listItems}</ul>`
    }
  },
  methods: {
    showFacilities (priceInfo) {
      this.amenities = priceInfo.amenities
      this.promotions = priceInfo.promotions
      this.facilitiesDialogVisible = true
    },
    setCancellationColor (value) {
      if (value === '1' || value === 1) {
        return '#007f61'
      } else if (value === '2' || value === 2) {
        return '#d99c00'
      } else {
        return '#cc0000'
      }
    },
    handleResize () {
      this.screenWidth = document.body.clientWidth
      if (this.screenWidth <= 1500) {
        this.screenWidth = 1500
      }
    },
    getPermissions (value) {
      this.allPermissions = value
    },
    getLanguageHtml: function (data, type) {
      if (['room-cancel'].includes(type)) {
        var html = ''
        html += this.$t('freeCancellationBefore')
        html += ' ' + data.fundableDate.en
        return html
      }
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 215
      } else {
        this.contentWidth = document.body.clientWidth - 64
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    hotelDetailCurrency: function (data) {
      this.currencySwitch = data
    },
    getPublicCurrency: function (data) {
      this.publicCurrency = data
    },
    hotelLanguage (language) {
      this.language = language
    },
    // 下拉置顶
    handleScroll: function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 60 && this.frameHotelSold === false && this.frameRise === false && this.frameHomeSold === false) {
        let width = this.contentWidth - 30
        this.hotelRoomSearchFixed = {'width': width + 'px', 'position': 'fixed', 'top': '0px', 'z-index': 1999}
        this.hotelRoomSearchFixedPlaceholder = {'display': 'block'}
      } else {
        this.hotelRoomSearchFixed = ''
        this.hotelRoomSearchFixedPlaceholder = ''
      }
    },
    // 查看所有图片
    seeMorePicturesShow: function () {
      this.$refs.seeMorePictures.style.display = 'block'
      // 轮播默认 第一个显示
      this.imgBackShow(0)

      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[0].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[0].id)
    },
    // 所有图片按钮 上一个
    prevImgShow: function () {
      var dataIndex = this.$refs.morePricturesMax.getAttribute('data-index')
      var prevIndex = dataIndex - 1
      if (prevIndex < 0) {
        prevIndex = this.hotelImg.length - 1
      }
      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[prevIndex].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[prevIndex].id)

      this.imgBackShow(prevIndex)
    },
    // 所有图片按钮 下一个
    nextImgShow: function () {
      var dataIndex = this.$refs.morePricturesMax.getAttribute('data-index')
      var nextIndex = Number(dataIndex) + 1
      if (nextIndex > (this.hotelImg.length - 1)) {
        nextIndex = 0
      }
      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[nextIndex].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[nextIndex].id)

      this.imgBackShow(nextIndex)
    },
    curImgShow: function (e) {
      var curIndex = e.target.attributes.dataIndex.value
      this.$refs.morePricturesMax.setAttribute('src', this.hotelImg[curIndex].url)
      this.$refs.morePricturesMax.setAttribute('data-index', this.hotelImg[curIndex].id)

      this.imgBackShow(curIndex)
    },
    imgBackShow: function (num) {
      for (var i = 0; i < this.hotelImg.length; i++) {
        this.$refs.currentPicturesDiv[i].style.background = 'gray'
      }
      this.$refs.currentPicturesDiv[Number(num)].style.background = 'none'
    },
    seeMorePicturesHide: function () {
      this.$refs.seeMorePictures.style.display = 'none'
    },
    focusData: function () {
      // 更改日期操作记录埋点
      this.clickPageAction('hotel_change_date', this.hotelid, {'hotelid': this.hotelid})

      if (document.body.clientWidth < 1001) {
        // 尺寸如果低于1001 则触发frame
        this.$refs.child.hotelSearchFrame = true
      } else {
        // 尺寸如果高于1001
        this.$refs.child.parentFocus()
        // window.scrollTo(0, 0)
        document.querySelector('#main').scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    selectHotelList: function () {
      // var regionselect = this.$refs.child.region_select
      var startdate = this.$refs.child.start_date
      var enddate = this.$refs.child.end_date
      var room = this.$refs.child.roomNum
      var adult = this.$refs.child.adultNum
      var child = this.$refs.child.childNum

      var regionSel = {'value_en': this.cityData.city, 'value_zh': this.cityData.chinese_name, 'type_id': 1, 'type_data_id': this.cityData.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var language = this.common.languageSet(this)
      var cityRegion = this.cityData.city
      if (language === 'zh') {
        cityRegion = this.cityData.chinese_name
      }
      var childNums = '[]'
      var searchData = localStorage.getItem('searchData')
      if (searchData !== '{}' && searchData !== null) {
        var params = JSON.parse(searchData)
        childNums = params.childNums
      }
      var searchJson = {'type': 1, 'type_id': this.cityData.id, 'region': cityRegion, 'start_date': startdate, 'end_date': enddate, 'room': room, 'adult': adult, 'child': child, 'childNums': childNums, 'source': this.source}
      localStorage.setItem('searchData', JSON.stringify(searchJson))

      // 搜索其他酒店住宿操作记录埋点
      this.clickPageAction('change_hotel', this.hotelid, searchJson)

      this.$router.push({name: 'HotelList', query: searchJson})
    },
    viewDetailShow: function (e) {
      // var display = e.currentTarget.parentElement.nextElementSibling.style.display
      var display = e.currentTarget.nextElementSibling.style.display
      if (display === '') {
        e.currentTarget.nextElementSibling.style.display = 'none'
      } else {
        e.currentTarget.nextElementSibling.style.display = ''
      }
    },
    // 局部刷新
    reload: function () {
      this.isPriceShow = false
      setTimeout(() => {
      }, 500)
    },
    // 获取报价方法
    hotelPrice: function () {
      this.common.stopScroll()
      this.isPriceShow = true
      // hotelQuotedprice
      var typeId = this.$route.query.hotelid
      this.hotelid = this.$route.query.hotelid
      var params = this.$route.query
      var region = this.$route.query.region
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
        region = params.region
        if (params.type === 3) {
          this.hotelid = params.type_id
          typeId = params.type_id
        }
      }
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      // var childNums = '[]'
      // if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && params.childNums !== undefined) {
      //   childNums = JSON.stringify(params.childNums)
      // }
      if (params === null || JSON.stringify(params) === '{}') {
        params = this.$route.query
        this.hotelid = params.hotelid
        region = params.region
        typeId = params.hotelid
      }
      var currency = this.common.currencySet(this)
      if (currency === undefined) {
        currency = this.publicCurrency
      }

      var type = 3
      var adult = parseInt(params.adult)
      var child = parseInt(params.child)
      var room = parseInt(params.room)
      if (room === 0 || isNaN(room)) {
        room = 1
      }
      var seleteds = ''
      var childNums = this.$route.query.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        }
      }
      var startdate = params.start_date
      var enddate = params.end_date
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      if (region === undefined || region === null) {
        region = ''
      }
      var endDateMonth = ''
      if (startdate === enddate) {
        var endDate = new Date(startdate)
        endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        enddate = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }
      if ((startdate === undefined && startdate !== null && startdate !== '' && startdate !== 'NAN-NAN-NAN') && (enddate !== undefined && enddate !== null && enddate !== '' && enddate !== 'NAN-NAN-NAN')) {
        var date1 = new Date()
        date1.setDate(date1.getDate() - 1)
        var date2 = new Date(date1)
        date2.setDate(date1.getDate() + 1)

        var startDateMonth = ((date1.getMonth() + 1) < 10) ? '0' + (date1.getMonth() + 1) : (date1.getMonth() + 1)
        endDateMonth = ((date2.getMonth() + 1) < 10) ? '0' + (date2.getMonth() + 1) : (date2.getMonth() + 1)

        var startDateDay = (date1.getDate() < 10) ? '0' + date1.getDate() : date1.getDate()
        var endDateDay = (date2.getDate() < 10) ? '0' + date2.getDate() : date2.getDate()
        startdate = (date1.getFullYear()) + '-' + startDateMonth + '-' + startDateDay
        enddate = (date2.getFullYear()) + '-' + endDateMonth + '-' + endDateDay
      }
      this.checkIn = startdate
      this.checkOut = enddate
      var localUrl = window.document.location.href

      var priceDataJson = {
        'hotelid': this.hotelid,
        'region': region,
        'type': type,
        'type_id': typeId,
        'room': room,
        'adult': adult,
        'child': child,
        'childNums': seleteds,
        'checkin': startdate,
        'checkout': enddate,
        'currency': currency,
        'token': token,
        'roompaiToken': roompaiToken,
        'sessionid': sessionid,
        'url': localUrl,
        'nationality': this.nationality,
        'operation': 'hotelQuotedprice',
        'time': time,
        'is_pkg': (params.is_pkg === null || params.is_pkg === undefined) ? 0 : params.is_pkg
      }
      var priceData = this.common.encryptionData(priceDataJson, this)
      hotelQuotedprice(priceData).then(res => {
        if (res.flag === '200') {
          sessionStorage.setItem('hotelQuotedPriceSesstionId', res.data.sessionIdStr)

          this.roomList = {}
          this.recommendHotelList = {}
          this.searchPriceData = {}
          this.roomList = res.data.roomPriceList
          this.searchPriceData = res.data.searchPriceData
          this.roomList.forEach(room => {
            room.priceInfo.forEach(price => {
              if (price.bedGroups && price.bedGroups.length > 0) {
                this.$set(price, 'selectedBedGroupId', price.bedGroups[0].id)
              } else {
                this.$set(price, 'selectedBedGroupId', null)
              }
            })
          })
          this.$forceUpdate()
          this.isPriceShow = false
          this.priceEmpty = false
        } else {
          this.isPriceShow = false
          this.priceEmpty = true
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(priceData, res, requestTime, responseTime)
        })
      })
      this.common.canScroll()
    },
    searchRecommendHotel: function () {
      var self = this
      var typeId = this.$route.query.hotelid
      this.hotelid = this.$route.query.hotelid
      var params = this.$route.query
      var region = this.$route.query.region
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
        region = params.region
        if (params.type === 3) {
          this.hotelid = params.type_id
          typeId = params.type_id
        }
      }

      // 用户
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      // 设备
      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }

      if (params === null || JSON.stringify(params) === '{}') {
        params = this.$route.query
        this.hotelid = params.hotelid
        region = params.region
        typeId = params.hotelid
      }

      var currency = this.common.currencySet(this)
      if (currency === undefined) {
        currency = 'USD'
      }

      var type = 3
      var adult = parseInt(params.adult)
      var child = parseInt(params.child)
      var room = parseInt(params.room)
      if (room === 0 || isNaN(room)) {
        room = 1
      }
      var seleteds = ''
      var childNums = this.$route.query.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        }
      }
      var startdate = params.start_date
      var enddate = params.end_date
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      if (region === undefined || region === null) {
        region = ''
      }

      if (startdate === enddate) {
        var endDate = new Date(startdate)
        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        enddate = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }
      this.checkIn = startdate
      this.checkOut = enddate
      var localUrl = window.document.location.href

      var priceDataJson = {
        'hotelid': this.hotelid,
        'region': region,
        'type': type,
        'type_id': typeId,
        'room': room,
        'adult': adult,
        'child': child,
        'childNums': seleteds,
        'checkin': startdate,
        'checkout': enddate,
        'currency': currency,
        'token': token,
        'roompaiToken': roompaiToken,
        'sessionid': sessionid,
        'url': localUrl,
        'operation': 'recommendHotel',
        'time': time
      }
      var priceData = this.common.encryptionData(priceDataJson, this)
      recommendHotel(priceData).then(res => {
        self.recommendHotelList = res.data.list
        self.$forceUpdate()

        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(priceData, res, requestTime, responseTime)
        })
      })
    },
    recommendGotoDetail: function (hotelid, hotelname, search) {
      var params = this.$route.query
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }

      var seleteds = ''
      var child = parseInt(params.child)
      var childNums = this.$route.query.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        }
      }

      var detailjson = {}
      detailjson['hotelid'] = hotelid
      detailjson['region'] = hotelname
      detailjson['start_date'] = search.checkin
      detailjson['end_date'] = search.checkout
      detailjson['room'] = search.roomcount
      detailjson['adult'] = search.adults
      detailjson['child'] = search.childcount
      detailjson['childNums'] = seleteds
      detailjson['language'] = this.common.languageSet(this)
      detailjson['currency'] = this.common.currencySet(this)
      detailjson['source'] = this.source

      // 选择客房操作记录
      this.clickPageAction('select_recommend_hotel', '', detailjson)

      let routeData = this.$router.resolve({name: 'HotelDetail', query: detailjson})
      window.open(routeData.href, '_blank')
    },
    parentRoomBook: function (product) {
      sessionStorage.setItem('productStr', JSON.stringify(product))
      this.fullscreenLoading = true

      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var region = ''
      var typeId = ''
      var params = this.$route.query
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
        region = params.region
        typeId = params.type_id
      }
      if (params === null || JSON.stringify(params) === '{}') {
        params = this.$route.query
        region = params.region
        typeId = params.hotelid
      }
      if (region === undefined || region === null) {
        region = ''
      }
      var type = 3
      var adult = parseInt(params.adult)
      var child = parseInt(params.child)
      var room = parseInt(params.room)
      var startdate = params.start_date
      var enddate = params.end_date
      if (room === 0 || isNaN(room)) {
        room = 1
      }
      var seleteds = ''
      var childNums = this.$route.query.childNums
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        if (childNums !== undefined) {
          seleteds = childNums
        } else {
          seleteds = []
        }
      }
      var time = parseInt(new Date().getTime() / 1000)
      var currency = this.common.currencySet(this)
      var sessionid = this.common.sessionidGet(this)

      var localUrl = window.document.location.href

      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      const selectedBed = product.bedGroups.find(bg => bg.id === product.selectedBedGroupId)
      // 在这里获取选中的床型信息
      const bedTypeId = selectedBed.id
      sessionStorage.setItem('bedType_' + this.hotelid, bedTypeId)

      var verifyJson = {
        'hotelid': this.hotelid,
        'product': JSON.stringify(product),
        'token': token,
        'region': region,
        'type': type,
        'type_id': typeId,
        'room': room,
        'adult': adult,
        'child': child,
        'childNums': seleteds,
        'checkin': startdate,
        'checkout': enddate,
        'currency': currency,
        'source': this.source,
        'sessionid': sessionid,
        'hotelUrl': localUrl,
        'roompaiToken': roompaiToken,
        'nationality': this.nationality,
        'operation': 'orderBookVerify',
        'time': time,
        'is_pkg': (product.isPkg === null || product.isPkg === undefined) ? 0 : product.isPkg,
        'bedTypePreferenceId': bedTypeId
      }
      var verifyData = this.common.encryptionData(verifyJson, this)
      orderBookVerify(verifyData).then(res => {
        this.fullscreenLoading = false
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else if (res.flag === '110') {
          // 无权限
          location.reload()
        } else if (['155', '150'].includes(res.flag)) {
          // 无母房型有报价
          this.frameHotelSoldDialog = true
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
        } else if (res.flag === '153') {
          // 涨价
          this.frameRiseDialog = true
          this.risePrice = res.data.priceRise
        } else if (res.flag === '163') {
          this.frameChangeRoomDialog = true
          this.sameRoomInfo = res.data.sameRoomInfo
        } else if (res.flag === '173') {
          this.frameChangePriceAndRoomDialog = true
          this.sameRoomInfo = res.data.sameRoomInfo
          this.risePrice = res.data.priceRise
        } else if (res.flag === '200') {
          // 成功
          var orderData = {
            'hotelid': this.hotelid,
            'product': JSON.stringify(product),
            'checkin': startdate,
            'checkout': enddate,
            'room': room,
            'adult': adult,
            'child': child,
            'childNums': seleteds,
            'hotelUrl': localUrl,
            'source': this.source
          }
          localStorage.setItem('orderData', JSON.stringify(orderData))
          this.$router.push({name: 'WriteOrder', params: orderData})
        }
        return res
      }).then(res => {
        this.$nextTick(() => {
          // 埋点日志记录
          var bookNow = {
            'product_price': product.totalprice,
            'product_currency': product.currency,
            'product_id': product.id,
            'product_subid': product.subid,
            'hotelid': this.hotelid,
            'checkin': startdate,
            'checkout': enddate,
            'adults': adult,
            'child': child,
            'room': room
          }
          this.clickPageAction('book_now', '', bookNow, verifyData, res)
        })
      })
    },
    getSearchInfo: function (val) {
      this.checked_breakfast = false
      this.checked_cancel = false

      this.roomList = []
      var type = val['type']
      if (type === undefined) {
        type = 3
      }
      var typeId = val['type_id']
      if (typeId === undefined) {
        typeId = this.$route.query.hotelid
      }
      this.nationality = val['nationality']

      var search = {}
      search['type'] = type
      search['type_id'] = typeId
      search['region'] = val['region']
      search['start_date'] = val['start_date']
      search['end_date'] = val['end_date']
      search['room'] = val['room']
      search['adult'] = val['adult']
      search['child'] = val['child']
      search['childNums'] = val['childNums']
      search['source'] = this.source
      search['nationality'] = this.nationality
      search['is_pkg'] = val['is_pkg']
      localStorage.setItem('searchData', JSON.stringify(search))
      if (val['region'] !== this.region) {
        this.$router.push({name: 'HotelList', query: search})
      } else {
        this.publicCurrency = this.common.currencySet(this)
        var time = parseInt(new Date().getTime() / 1000)
        var query = JSON.parse(JSON.stringify(this.$route.query))
        query.start_date = val['start_date']
        query.end_date = val['end_date']
        query.room = val['room']
        query.adult = val['adult']
        query.child = val['child']
        query.childNums = []
        query.childNums = val['childNums']
        query.currency = this.publicCurrency
        query.source = this.source
        query.nationality = this.nationality
        query.ss = time
        query.is_pkg = val['is_pkg']
        this.$router.push({path: this.$route.path, query: query})
        this.reload()
        this.hotelPrice()

        window.scrollTo({
          top: 400,
          behavior: 'instant'
        })
      }
    },
    frameRiseBookingBackFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
    },
    frameChangeRoomBookingBackFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangePriceAndRoomBookingBackFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
    },
    getCityIdFun: function () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.cityData = res.data.hotelCity
      })
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'room-info-pc') {
        var element = document.getElementsByClassName('room-info-desc')
        for (var i = 0; i < element.length; i++) {
          element[i].style.display = 'none'
        }
      }
    },
    closepopEven: function (type) {
      if (type === 'whatNearbyShow') {
        this.whatNearbyShow = false
      }
      if (type === 'hotelPriceRoomImgShow') {
        this.hotelPriceRoomImgShow = false
      }
    }
  }
}
</script>

<style scoped>
.hotellist-main /deep/ .el-header {
  position: absolute;
}
/* 左侧 menu*/
.main{width:100%;}

/* 搜索条件 开始 */
.list-content{color: #333; background: #FFF; border-radius: 5px; padding: 15px 1%;}
/* 目的地 */
/* .input-region{width: 361px; height: 48px;} */
.hotellist-region /deep/ .el-input__inner{padding: 0 60px;height: 48px; background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;}
.location-search .hotellist-region{width:35%;}
.el-autocomplete{width:100%;}
/* .el-autocomplete /deep/ .el-input__inner{ font-size: 16px;} */
.hotellist-region input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
.hotellist-region input:focus,.hotellist-date.el-range-editor.is-active, .hotellist-date.el-range-editor.is-active:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.my-autocomplete .name {height:25px;text-overflow: ellipsis;overflow: hidden;font-weight: 650; color:rgba(83, 102, 163, 1);}
.my-autocomplete .addr {height:25px;font-weight: 100;color: rgba(83, 102, 163, 1);}
.my-autocomplete .highlighted .addr {color: #ddd;}
/* 日期 */
.hotellist-date{padding: 0px 50px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
.el-range-editor.el-input__inner{display:inline-block;}
.el-date-editor--daterange.el-input__inner{ width:30%;}
.input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 23px;background-position: 0px center;}
.hotellist-date .el-range__icon{margin-left:0px;}
/deep/ .el-date-editor .el-range-separator {display: none;}

/* 入住人 */
.person-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.inphotellistut-person .person-inner:hover{border-color:rgb(252, 210, 5, 1);}
/* .el-select-dropdown{display:none;} */
.personLessno{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png"); border: none; background-color: #fff;}
.personLessno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png")}
.personLess{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
.personLess:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
.personnum{position: relative;display: inline-block;width: 224px;line-height: 38px;text-align: center;}
.personAdd{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");border: none; background-color: #fff;}
.personAdd:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
.personAddno{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png");}
.personAddno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png")}
.personnum span{display:inline-block;}
.personnum input{border:none;outline:none;width:20px;height:32px;color:#409EFF;font-weight: 400; font-size: 18px;}
.personnum input:focus{border:0;outline:none;width:20px;height:32px;}
.spantext{color:#999999; font-size: 14px;}
.select-person{display:inline-block; width:20%;vertical-align: -webkit-baseline-middle;}
.showPersonBorder{border-color:rgb(252, 210, 5, 1);box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.showPersonBorder:hover{border-color:rgb(252, 210, 5, 1);}
.personText{font-weight: 650; font-size:14px;color: #4F4C4C;display:block;white-space: nowrap;overflow: hidden;}
.roomText{font-size:14px;color: #999999;white-space: nowrap;overflow: hidden;}
.childinfo .el-select-dropdown,.el-select-dropdown{display:block}
.selectOld{width: 40%;float: left;margin-left: 5%; margin-top: -7%;}
/* 加减成人 */
.personLessno{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png");}
.personLess{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
/* 入住人选择 */
.personInfo{border-width: 0px;position: absolute;left: 61.2%;width: 224px;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 4px;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);-webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); color: #999999;font-size: 14px;}
/* 搜索条件 结束 */
/* 手机版 */
  .location-search-mobile {width:95%;height:64px;line-height:64px;margin: 8px auto;}
  .mobile-search{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/hotelsearch/4F4C4C.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.mobile-search:hover{border-color:rgb(252, 210, 5, 1);}
.mobile-keyword-search{display: inline-block;}
.mobile-keyword-search input{float:right;height:40px;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/hotelsearch/2-4F4C4C.png);background-repeat:no-repeat;background-size: 20px;background-position: 15px center;padding: 0px 50px;font-size: 14px;opacity:1;border:1px solid rgba(221, 223, 226, 1);}
.list-top{height:40px;}
.top-search{vertical-align: -webkit-baseline-middle;margin: 10px 0px 9.3px 0px;color:#5392F9;}
.cond-search{vertical-align: -webkit-baseline-middle;margin-top: 20px;color:#fff;background-color:#5392F9;}
.blue-search,.blue-search:hover,.blue-search:focus{color:#fff !important;background-color:#5392F9 !important;border: 1px solid #5392F9;}
.blue-text{color:#5392F9;}
.el-icon-s-operation{margin-right: 2px;}
.el-icon-caret-bottom{margin-left:2px;}
.el-button:focus, .el-button:hover,.el-select .el-input.is-focus .el-input__inner{border:1px solid #DCDFE6;background: #FFF;}
.el-button+.el-button{margin-left: 0px;}
/* 手机版 */

/* 搜索结果 开始 */
/* 导航 */
.directory{height:40px;width:100%;font-size: 12px;text-align: left;line-height: 46px; margin: 10px 0;}
.directory a{text-decoration:none;color: #4F4C4C;}
.slash{color: #C0C4CC;padding:0px 5px 0px 5px;}
/* 细致搜索 */
.list-search-all{height:auto;}

/* 图片 */
.img-info{width: 100%; height: 250px;}
.main-img{ width: 100%; height: 100%; border-radius: 5px;}
.all-photos{position: absolute;
    bottom: 10px;
    right: 10px;
    color: white;
    font-size: 12px;
    border: solid 1px #ccc;
    border-radius: 3px;
    padding: 3px 12px;
    background: rgba(149,141,134,0.3);
    font-weight: bold;
    cursor: pointer;}

/* 查看更多图片 */
.seeMorePictures{width:100%;height:100%;display:none;}
.seeMorePictures .pricturesMask{width:100%;height:100%;background:black;position:fixed;top:0px;left:0px;z-index:10001;/* opacity: 0.6 !important; */}
.seeMorePictures .morePrictures{position: fixed;z-index: 10002;top: 20%;left: 10%;width: 100%;height: 70%;}
.seeMorePictures .morePrictures .morePricturesImg{float:left;width:80%;height:100%;}
.seeMorePictures .morePricturesLeft{width: 65%;height: 100%;float:left;position: relative;text-align: center;}
.seeMorePictures .morePricturesLeft img{/* width: 100%;*/height: 100%; max-width: -webkit-fill-available;max-height: -webkit-fill-available;}
.seeMorePictures .morePricturesLeft span{font-size: 77px; position: absolute; top: 40%;height:13%;  color: white; font-weight: 100;cursor:pointer;}
.seeMorePictures .morePricturesLeft .firstSpan{left: 0px;}
.seeMorePictures .morePricturesLeft .lastSpan{right: 0px;}
.seeMorePictures .morePricturesLeft .firstSpan img{width: 70px;height: 100%;}
.seeMorePictures .morePricturesLeft .lastSpan img{width: 70px;height: 100%;}
.seeMorePictures .morePricturesRight{width: 35%;height:100%;float:right;overflow-y: scroll;overflow-x: hidden;}
.seeMorePictures .morePricturesRight::-webkit-scrollbar {width: 2px;}
.seeMorePictures .morePricturesRight .morePricturesRightImg{width: 48%; height: 100px;float: left;margin: 2px;position:relative;}
.seeMorePictures .morePricturesRight .morePricturesRightImg img{width: 100%;height: 100%;}
.seeMorePictures .morePricturesRight .morePricturesRightImg div{width: 100%;height: 100%; background: gray;position: absolute;top: 0px;left: 0px;opacity: 0.6;}
.seeMorePictures .closeRight{width: 40px;height: 100%;float: left;text-align: center;line-height: 20px;}
.seeMorePictures .closeRight span{font-size: 54px;color: white;font-weight:100;cursor:pointer;}

/* 详情 */
.hotelname-info{height: 30px; line-height: 30px;font-size: 28px; font-weight: 650; color:rgba(83, 102, 163, 1);margin-bottom: 10px;}
.hotel-contact-info{font-size: 12px; height: 35px;line-height: 35px;}
.hotel-contact-info img{height:15px; float: left; margin: 10px 0;}
.hotel-contact-info div{display: inline-block; float: left;}
/deep/ .el-collapse-item__header, .el-collapse, /deep/ .el-collapse-item__wrap{border: none; background-color: #FFF;}
.list-content /deep/ .el-collapse-item__arrow{ display: none;}
.overview-info div{display: inline-block; margin-right: 20px;}

/* 报价 */
.pricelist{width: 96%; background-color: #FFF;height: 40px;border: none; font-weight: 650; font-size: 16px; color: #333333; line-height: 40px; padding: 0 2%;border-bottom: 1px solid #d2cfcf;}
.pricelist div, .price-info div{display: inline-block; float: left;}
.price-info{ width: 100%; border: none; color: #333333;clear: both; background-color: #FFF;}
.price-info-val{width: 98%; padding: 0 1%;border-bottom: 1px solid #d2cfcf;}
.parent-room{
  width: 14%; font-size: 14px;float: left; background-color: #FFF;
  display: flex;
  align-items: center; /* 新增此行 */
  justify-content: center;
}
.price-item{width: 84%;float: right; height: 65px; line-height: 65px; background-color: #FFF;}
.price-border{ border-bottom: 1px solid #d2cfcf;}
.title-txt{width: 100px;margin: 13.5px 0;}
.list-txt{width: 50%;margin: 25.5px 0;}
.others-room{height: 20px;line-height: 20px; margin: 10px 0 5px 0; display: -webkit-box; -webkit-line-clamp: 1; overflow: hidden; text-overflow: ellipsis; max-width: 100%;-webkit-box-orient: vertical;}

/* 详细报价 */
.price-title-data-detail-top{border-radius: 2px;}
.price-title-data-detail-top{width:100%; height:40px;background:rgba(83, 102, 163, 1);color:#fff;border-top-left-radius: 5px;border-top-right-radius: 5px;line-height:40px;}
.price-title-data-detail-center{width:92%;margin:0 auto;}
.price-title-data-detail-body{width:100%;}
.price-title-data-detail-line{width:100%;height:20px;/*line-height:40px;*/font-size:14px;padding-top:20px;}
.price-title-data-detail-min{width:100%;height:20px;line-height:20px;}
.price-title-data-detail-line .price-title-data-detail-line-left{width:50%;height:100%;float:left;text-align:left;}
.price-title-data-detail-line .price-title-data-detail-line-left .zhu-cont{display: block;line-height: 30px;}
.price-title-data-detail-line .price-title-data-detail-line-left .avgprice{display: block;font-size: 12px;line-height: 0px;color: #838383;}
.font-min{font-size: 12px;color:#838383;}
.price-title-data-detail-line .price-title-data-detail-line-right{width:50%;height:100%;float:right;text-align:right;}
.price-padding{padding-bottom:20px;}
.price-infos{width: 12%;font-size: 14px; text-align: center; float: left;}
.price-infos .price-title-data-top{width: 100%;height: 55%;}

/*价格样式*/
.currencyTag-info {
  font-size: 14px;
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
}

.payPrice-info {
  color: #9455A1;
  font-weight: 600;
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
}
.point-info{
  margin-left: 2px;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #2F7000;
  display: inline-block;
  vertical-align: middle;
}

.hotel-policies-container {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0px;
  background: #fff;
  padding: 10px 1% 0px;
  border-radius: 5px;
}

.policy-block {
  width: 49%;
  margin: 10px 10px 20px 0px;
}

.policy-block h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.policy-block .policy-content {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}

.check-info-container {
  display: flex;
  justify-content: space-between;
}

.check-info-block {
  width: 48%;
}

.check-info-title {
  color: #4E7997;
  font-size: 14px;
  margin-bottom: 10px;
}

.check-info-content p {
  margin: 8px 0;
  line-height: 1.5;
}

.policy-block .policy-content p {
  margin: 5px 0;
}

.policy-block .policy-content ul {
  margin: 5px 0;
  padding-left: 20px;
}

.room-name {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.container {
    margin-top: 15px;
    background-color: #ffffff;
    padding: 15px 1%;
    border-radius: 4px;
    line-height: 1.5;
}

.container h1 {
    text-align: left;
    color: rgb(83, 102, 163);
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

/* 政策列布局 */
.policy-columns {
    display: flex;
    /* 允许列在需要时换行，虽然对于两列来说不那么关键 */
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}

.policy-column {
    flex: 1 1 45%;
    min-width: 300px; /* 确保在小屏幕下换行前有一个最小宽度 */
}

/* CSS规则：用于隐藏空的列 (这需要通过 JS 或模板逻辑来添加 `.empty` 类) */
.policy-column.empty {
    display: none; /* 如果列为空，则完全隐藏该列 */
}

/* 政策模块样式 */
.policy-module {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 15px 20px;
    margin-bottom: 20px;
}

/* 移除每列中最后一个模块的底部外边距，使布局更紧凑 */
.policy-module:last-child {
    margin-bottom: 0;
}

.policy-module h2 {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    padding-left: 0;
}

/deep/ .policy-module ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
}

/deep/ .policy-module li {
    position: relative;
    margin-bottom: 8px;
    padding-left: 0; /* 如果不使用自定义项目符号，则无需内边距 */
    font-size: 13px;
    color: #555;
}

.policy-module-text {
    position: relative;
    margin-bottom: 8px; /* Adjusted: Slightly reduced list item spacing */
    padding-left: 0; /* Adjusted: Removed padding for custom bullet if not needed */
    font-size: 13px; /* Adjusted: Slightly smaller font size */
    color: #555;
}

.policy-module div {
  font-size: 14px;
}

.policy-content >>> li {
  list-style-type: disc;
  margin-left: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .policy-columns {
        flex-direction: column;
        gap: 20px;
    }
    .policy-column {
        min-width: 100%;
    }
    .policy-module {
        padding: 15px; /* Adjust padding for smaller screens if needed */
    }
}

/* 取消政策弹框样式 */
.cancel-policy {
  background: #fff;
  padding: 12px;
  /* max-height: 150px; */
  overflow-y: auto;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-item {
  display: flex;
  align-items: flex-start;
  background: #fff;
}

.cancel-policy .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.cancel-policy .circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid #cc0000; /* 修改为边框 */
  background: transparent; /* 背景设置为透明 */
  margin-top: 6px;
  margin-right: 8px;
  flex-shrink: 0;
}

.cancel-policy .text-content {
  flex: 1;
}

.cancel-policy .subtitle {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
  font-weight: 500;
}

.cancel-policy .description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* 弹框容器样式 */
.nonFefundable {
  background: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 180px !important;
  height: auto !important;
}

.package-tag {
  background: #F6FFED;
  color: #52C41A;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #B7EB8F
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}

/deep/ .facilities-dialog .el-dialog__body{
  padding: 0px 20px 30px;
}

.facilities-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.facilities-list li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.facilities-list li i {
  font-size: 18px;
  margin-right: 10px;
  color: #6c5ce7;
}

.dialog-footer .el-button {
  border-radius: 5px;
}

/* You might need to adjust icon colors if they don't match exactly */
.facilities-list li .el-icon-present,
.facilities-list li .el-icon-time,
.facilities-list li .el-icon-magic-stick {
    color: #20c997;
}

.facilities-divider {
    width: 100%;
    height: 1px;
    background: #e5e6eb;
    margin-bottom: 15px;
    border: none;
  }

.arrow-icon {
  margin-right: 10px; /* 箭头与文字的间距 */
  color: #5366a3; /* 箭头颜色，可以根据品牌色调整 */
  font-size: 0.9em; /* 调整箭头大小 */
}

</style>
<style>
.el-drawer__open .el-drawer.btt{height:auto !important;}
.el-tooltip__popper.is-light {
  max-width: 300px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  line-height: 1.5 !important;
  padding: 8px 12px !important;
  background: #999999 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/HotelDetail.vue